import React, { Component } from 'react'

import Dropzone from 'react-dropzone'

import FileList from '../FileList/index'

import './style.css'

export default class Upload extends Component {
  
  renderDragMessage = (isDragActive, isDragReject) => {
    if(!isDragActive) {
      return <div className="uploadMessage">Arraste os arquivos aqui...</div>
    }

    if(isDragReject) {
      return <div className="uploadMessage">Arquivo não suportado</div>
    }

    return <div className="uploadMessage">Solte os arquivos aqui</div>
  }

  render() {
    const { onUpload } = this.props;
    return(
      <div>
        <Dropzone onDropAccepted={onUpload}>
          { ({ getRootProps, getInputProps, isDragActive, isDragReject }) =>(
            <div className="dropContainer"
              { ...getRootProps() }
              isDragActive={isDragActive}
              isDragReject={isDragReject}>
              <input { ...getInputProps() } />
              { this.renderDragMessage(isDragActive, isDragReject) }
            </div>
          ) }
        </Dropzone>
      </div>
    );
  }
}